import { SetStateAction, Dispatch } from 'react';
import '../App.css';
import '../style.css';
import { Link } from 'react-router-dom';
import { FilterItem } from './FilterItem';


function ChipFilter(props: {
  activeFilter: number, 
  setActiveFilter: Dispatch<SetStateAction<number>>,
}) {

  
  return (
    <div className='filter'>
      <div className='filter-content'>
        <Link to="/work?filter=Recent" onClick={() => props.setActiveFilter(0)} style={{textDecoration: 'none'}}>
            <FilterItem isSelected={props.activeFilter === 0 } name='Recent' isRecent={true} />
        </Link>
        <Link to="/work?filter=All" onClick={() => props.setActiveFilter(1)} style={{textDecoration: 'none'}}>
            <FilterItem isSelected={props.activeFilter === 1 } name='All' />
        </Link>  
        <Link to="/work?filter=App" onClick={() => props.setActiveFilter(2)} style={{textDecoration: 'none'}}>
            <FilterItem isSelected={props.activeFilter === 2 } name='App' />
        </Link>
        <Link to="/work?filter=Web" onClick={() => props.setActiveFilter(3)} style={{textDecoration: 'none'}}>
            <FilterItem isSelected={props.activeFilter === 3 } name='Web' />
        </Link> 
        <Link to="/work?filter=2024~25" onClick={() => props.setActiveFilter(4)} style={{textDecoration: 'none'}}>
            <FilterItem isSelected={props.activeFilter === 4 } name= '2024~25' />
        </Link> 
        <Link to="/work?filter=2022~23" onClick={() => props.setActiveFilter(5)} style={{textDecoration: 'none'}}>
            <FilterItem isSelected={props.activeFilter === 5 } name='2022~23' />
        </Link> 
        <Link to="/work?filter=2021~19" onClick={() => props.setActiveFilter(6)} style={{textDecoration: 'none'}}>
            <FilterItem isSelected={props.activeFilter === 6 } name='2021~19' />
        </Link> 
      </div>
    </div>
  );
}

export default ChipFilter;

